import ShipmentType from './ShipmentType';
export default ShipmentType;
